import React, { useRef } from 'react';

import Autocomplete from "react-google-autocomplete";

export default ({ setfields, fields, setValidationErrors, fieldNames, ...props }) => {
  
  const handleError = (error) => {
    console.error('Error selecting place:', error);
  };
  const autocompleteRef = useRef(null);

  const handleInputBlur = () => {
    // If the input field loses focus and is empty, clear the selected place
    if (autocompleteRef.current && !autocompleteRef.current.value) {
      const emptyFields = {};
      fieldNames.forEach(name => {
          emptyFields[name] = '';
      });
      setfields(emptyFields);
    }
  };
  return (
    <Autocomplete
        ref={autocompleteRef}
        apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
        defaultValue={fields.academy_location}
        className="form-control" 
          onPlaceSelected={(place) => {
            const location = place?.formatted_address;
            const lat = place?.geometry?.location.lat();
            const lng = place?.geometry?.location.lng();
            const updatedFields = {};
            fieldNames.forEach(name => {
              if (name === 'academy_location') {
                updatedFields[name] = location;
              } else if (name === 'academy_latitude') {
                updatedFields[name] = lat;
              } else if (name === 'academy_longitude') {
                updatedFields[name] = lng;
              }
            });
            setfields((prev) => ({
              ...prev,
              ...updatedFields
            }));
            setValidationErrors({academy_location : ""});

        }}
          onBlur={handleInputBlur}
          onError={handleError}

    />
  );
};
